// extracted by mini-css-extract-plugin
export default {"head":"Navbar_head__CTMP+","img":"Navbar_img__D2p9l","loginBtn":"Navbar_loginBtn__PxI9r"};